import { getNumberFormatter } from 'utils';

export const bytesToMegabytes = (bytes: number) => {
  const megabytes = bytes / (1024 * 1024);
  return getNumberFormatter('ru-RU', {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  }).format(megabytes);
};
